export default "__VITE_ASSET__c50ffdd7__"